// Deterministic placeholder gradient from an ID.
//
// Replaces blank card backgrounds with a subtle brand-adjacent gradient while
// the real image decodes. Means re-entry never appears "empty" — the LQIP
// pattern every streaming site uses (Unsplash, Netflix, Next.js Image).
// Cheaper than ThumbHash because it requires no backend support.

const hash = (str) => {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
};

export const getPlaceholderGradient = (id) => {
  if (!id) return "linear-gradient(135deg, #1f1f23 0%, #16161a 100%)";
  const h = hash(String(id));
  const hue1 = h % 360;
  const hue2 = (hue1 + 40) % 360;
  return `linear-gradient(135deg, hsl(${hue1} 18% 14%) 0%, hsl(${hue2} 22% 9%) 100%)`;
};
